import { render, staticRenderFns } from "./branch-top-panel.vue?vue&type=template&id=1f9e3814&"
import script from "./branch-top-panel.vue?vue&type=script&lang=js&"
export * from "./branch-top-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports